import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import {
  Dashboard as DashboardIcon,
  Settings as SettingsIcon,
  Close as CloseIcon,
  List as ListIcon,
  Palette as PaletteIcon,
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  Mail as MailIcon,
  SupportAgent as SupportAgentIcon,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import MessagingService from '../../services/MessagingService';

const Sidebar = ({ isOpen, isMobile = false, toggleSidebar }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const supportOpen = currentPath === '/messages'
    && new URLSearchParams(location.search).get('support') === '1';
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadUnread = async () => {
      try {
        const count = await MessagingService.unreadCount();
        if (!cancelled) {
          setUnread(Number(count) || 0);
        }
      } catch (error) {
        if (!cancelled) {
          setUnread(0);
        }
      }
    };
    loadUnread();
    return () => {
      cancelled = true;
    };
  }, [currentPath]);

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  return (
    <>
      {isOpen && isMobile && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">Ma boutique</h2>
          <button
            type="button"
            className="sidebar-close"
            onClick={toggleSidebar}
            aria-label="Fermer le menu"
          >
            <CloseIcon />
          </button>
        </div>

        <div className="sidebar-content">
          <nav className="sidebar-nav">
            <div className="nav-section">
              <h3 className="nav-section-title">Navigation</h3>
              <ul className="nav-list">
                <li className={currentPath === '/dashboard' ? 'active' : ''}>
                  <Link to="/dashboard" className="nav-item">
                    <DashboardIcon />
                    <span>Tableau de bord</span>
                  </Link>
                </li>
                <li className={currentPath === '/products' || currentPath === '/' ? 'active' : ''}>
                  <Link to="/products" className="nav-item">
                    <ListIcon />
                    <span>Liste des produits</span>
                  </Link>
                </li>
                <li className={currentPath === '/messages' ? 'active' : ''}>
                  <Link to="/messages" className="nav-item">
                    <MailIcon />
                    <span>Messages{unread > 0 ? ` (${unread})` : ''}</span>
                  </Link>
                </li>
                <li className={currentPath === '/settings' ? 'active' : ''}>
                  <Link to="/settings" className="nav-item">
                    <SettingsIcon />
                    <span>Paramètres</span>
                  </Link>
                </li>
                <li className={`nav-parent ${submenuOpen ? 'open' : ''}`}>
                  <div className="nav-item" onClick={toggleSubmenu}>
                    <SettingsIcon />
                    <span>Configuration</span>
                  </div>
                  <ul className={`nav-submenu ${submenuOpen ? 'open' : ''}`}>
                    <li className={currentPath === '/appearance' ? 'active' : ''}>
                      <Link to="/appearance" className="nav-item">
                        <PaletteIcon />
                        <span>Apparence</span>
                      </Link>
                    </li>
                    <li className={currentPath === '/creator-info' ? 'active' : ''}>
                      <Link to="/creator-info" className="nav-item">
                        <PersonIcon />
                        <span>Informations</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="sidebar-footer">
          <Link
            to="/messages?support=1"
            className={`contact-support-btn${supportOpen ? ' is-active' : ''}`}
          >
            <SupportAgentIcon />
            <span>Contacter le support</span>
          </Link>
          <a
            href={process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL || 'http://app.local.dev:8080'}
            className="back-to-app-btn"
          >
            <ArrowBackIcon />
            <span>Retour à l'application</span>
          </a>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
